/* eslint-disable react/prop-types */
/* eslint-disable react/no-children-prop */
/* eslint-disable react-native/no-inline-styles */
/*
Author: Gilang Romadhanu Tartila
*/

import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { View, StyleSheet, TouchableOpacity } from 'react-native';
import Toast from 'react-native-toast-message';
import ModalTopRounded from '@components/modal/ModalTopRounded';
import Colors from '@global/colors';
import { isWeb, isMobileWeb } from '@global/screens';
import { showPopup } from '@/store/modal';
import Image from '@components/global/Image';
import SociollaText from '@components/sociolla/SociollaText';
import SelectProductTable from '@components/form/SelectProductTable';
import importTemplate from '@/assets/csv/template-import-mt-bt-account-products';
import ModalUpload from '@components/modal/ModalUpload';

import { MsB2b } from '@api/ms-b2b';

const CreateNewOption = (props) => {
  const dispatch = useDispatch();
  const showImportModalAccountProduct = useSelector(
    (state) => state.modal.showImportModalAccountProduct,
  );

  const [showProduct, setShowProduct] = useState(false);

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      setShowProduct(false);
    }
    return () => {
      mounted = false;
    };
  }, [props.show]);

  const addProduct = () => {
    setShowProduct(true);
  };

  const onSelectProduct = (data, is_bulk = false) => {
    try {
      if (is_bulk) {
        props.onCallbackBulk(data);
      } else {
        props.onCallback(data);
      }
      setShowProduct(false);
    } catch (err) {}
  };

  const onUpload = async (url) => {
    const failed = () => {
      Toast.show({ text1: 'A system error occurred', type: 'error' });
      dispatch(
        showPopup({ name: 'showImportModalAccountProduct', value: false }),
      );
    };
    try {
      const response = await MsB2b.createMarketTypeProductBulk(
        props?.route?.params?.id,
        {
          url,
          is_premium: props.isPremium,
        },
      );
      if (response.status == 200) {
        Toast.show({
          text1: 'CSV upload successful',
          type: 'success',
        });
        dispatch(showPopup({ name: 'isLoading', value: false }));
        dispatch(
          showPopup({ name: 'showImportModalAccountProduct', value: false }),
        );
        onSelectProduct([], true);
      } else {
        failed();
      }
    } catch (err) {
      console.log('Something wrong!', err);
      failed();
    }
  };

  return (
    <View>
      <ModalTopRounded
        title="Add Product"
        visible={props.show}
        maxWidth={isWeb && !isMobileWeb ? 500 : '100%'}
        onClose={() =>
          dispatch(showPopup({ name: 'marketCreateOption', value: false }))
        }
        children={
          <View style={styles.marketCreate}>
            <TouchableOpacity
              activeOpacity={0.6}
              style={styles.itemOption}
              onPress={() => addProduct()}>
              <Image
                style={{ width: 43, height: 43 }}
                width={43}
                height={43}
                source={require('@assets/img/icons/add-manually-market-type.png')}
              />
              <SociollaText style={styles.itemText}>Add Manually</SociollaText>
            </TouchableOpacity>
            <TouchableOpacity
              activeOpacity={0.6}
              style={styles.itemOption}
              onPress={() => {
                dispatch(
                  showPopup({ name: 'marketCreateOption', value: false }),
                );
                dispatch(
                  showPopup({
                    name: 'showImportModalAccountProduct',
                    value: true,
                  }),
                );
              }}>
              <Image
                style={{ width: 35, height: 43 }}
                width={35}
                height={43}
                source={require('@assets/img/icons/add-from-csv.png')}
              />
              <SociollaText style={styles.itemText}>Import CSV</SociollaText>
            </TouchableOpacity>
            <SelectProductTable
              show={showProduct}
              onClose={() => setShowProduct(false)}
              onCallback={(val) => onSelectProduct(val)}
            />
          </View>
        }
      />
      {showImportModalAccountProduct ? (
        <ModalUpload
          show={showImportModalAccountProduct}
          onClose={() =>
            dispatch(
              showPopup({
                name: 'showImportModalAccountProduct',
                value: false,
              }),
            )
          }
          templateUrl={importTemplate}
          onUpload={onUpload}
          autoUploadS3={true}
          name={'import_account_product'}
          validHeader={['sku']}
        />
      ) : (
        false
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  marketCreate: {
    width: '100%',
    paddingHorizontal: isWeb ? 25 : 15,
    paddingTop: isWeb ? 25 : 15,
    paddingBottom: isWeb ? 40 : 15,
    flexDirection: 'row',
    justifyContent: 'center',
  },
  itemOption: {
    padding: 15,
    textAlign: 'center',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 5,
    borderColor: Colors.grey0,
    borderWidth: 1,
    marginHorizontal: isWeb ? 15 : 10,
  },
  itemText: {
    fontSize: 14,
    marginTop: 15,
  },
});

export default CreateNewOption;
